import { merge } from 'lodash';

import { buildDisneyCrmQuery } from '../utils/query';

/**
 * @description Get Disney subscriber information
 *
 * @param {Object} [options]
 * @returns {QueryConfig}
 */
export const getDisneySubscriber = buildDisneyCrmQuery(
  ({ token }) => ({
    url: `/users`,
    options: {
      authorization: 'Bearer ' + token,
      method: 'GET'
    },
    force: true,
    transform: (response) => {
      return {
        subscriptions: { disneySubscription: response }
      };
    },
    update: {
      subscriptions: merge,
    },
  })
);

export default null;
